import { useLoginModal } from "@/context/LoginModalContext";
import { usePassportProvider } from "@/context/PassportProvider";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { LoadingModal } from "../core/LoadingModal";
import { GenericBonusModal } from "./GemBonusModal";
import { useBonus } from "./useGemBonus";

const GemBonusContent = () => {
  const { bonusModalState, setBonusModalState, bonusDetails } = useBonus();

  const { openLoginModal } = useLoginModal();
  const { t } = useTranslation();
  const { isLoggingIn } = usePassportProvider();

  return (
    <>
      {bonusModalState !== undefined ? (
        <GenericBonusModal
          bonusDetails={bonusDetails}
          state={bonusModalState}
          onLogin={openLoginModal}
          onClose={() => setBonusModalState(undefined)}
        />
      ) : null}
      <LoadingModal
        loading={isLoggingIn}
        text={[t("logging_in"), t("logging_in_popup")]}
        closeable={true}
        loopingText={false}
      />
    </>
  );
};

export const GemBonus = () => {
  return (
    <Suspense fallback={null}>
      <GemBonusContent />
    </Suspense>
  );
};
